import * as React from 'react';
import * as icons from './Icons';
import { useRenderers } from '../renderProps';
import type { EngineRenderers } from '../renderProps';

export type OverridedIcons = { [iconName: string]: React.FunctionComponent };
const overridedIcons = {} as OverridedIcons;

Object.entries(icons).forEach(([name, icon]) => {
	overridedIcons[name] = (props: Record<string, unknown>) => {
		const renderers = useRenderers();
		const componentName = name as keyof EngineRenderers;

		if (renderers.hasOwnProperty(componentName) && renderers[componentName]) {
			const Component = renderers[componentName] as React.FC<Record<string, unknown>>;

			return <Component {...props} />;
		}

		const DefaultIcon = () => icon;

		return <DefaultIcon {...props} />;
	};
});

export { overridedIcons };
export * from './Icons';
